module.exports = {
  "zones": {
    "Europe/Tiraspol": ["z", {
      "wallclock": 852076800000,
      "format": "EE%sT",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": 852069600000,
      "save": 0,
      "rules": "Moldova"
    }, {
      "wallclock": 694224000000,
      "format": "EE%sT",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": 694216800000,
      "save": 0,
      "rules": "E-Eur"
    }, {
      "wallclock": 641959200000,
      "format": "EE%sT",
      "abbrev": "EEST",
      "offset": 7200000,
      "posix": 641944800000,
      "save": 3600000,
      "rules": "Russia"
    }, {
      "wallclock": -800150400000,
      "format": "MSK/MSD",
      "abbrev": "MSK",
      "offset": 10800000,
      "posix": -800157600000,
      "save": 0,
      "rules": "Russia"
    }, {
      "wallclock": -898128000000,
      "format": "CE%sT",
      "abbrev": "CEST",
      "offset": 3600000,
      "posix": -898138800000,
      "save": 3600000,
      "rules": "C-Eur"
    }, {
      "wallclock": -927158400000,
      "format": "EEST",
      "abbrev": "EEST",
      "offset": 7200000,
      "posix": -927165600000,
      "save": 3600000
    }, {
      "wallclock": -1213142400000,
      "format": "EE%sT",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": -1213148664000,
      "save": 0,
      "rules": "Romania"
    }, {
      "wallclock": -1637107200000,
      "format": "BMT",
      "abbrev": "BMT",
      "offset": 6264000,
      "posix": -1637114100000,
      "save": 0
    }, {
      "wallclock": -2840140800000,
      "format": "CMT",
      "abbrev": "CMT",
      "offset": 6900000,
      "posix": -2840147720000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 6920000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Moldova": [{
      "from": 1997,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1997,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }],
    "E-Eur": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1979,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }],
    "Russia": [{
      "from": 1985,
      "to": 2010,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 2010,
      "month": 9,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1984,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1981,
      "to": 1983,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 1,
      "day": [7, 14],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "MSD",
      "saved": 0
    }, {
      "from": 1921,
      "to": 1921,
      "month": 2,
      "day": [7, 20],
      "time": 1380,
      "clock": "wallclock",
      "save": 120,
      "letter": "+05",
      "saved": 3600000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 8,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "MSD",
      "saved": 7200000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 1919,
      "to": 1919,
      "month": 4,
      "day": [7, 31],
      "time": 1380,
      "clock": "wallclock",
      "save": 120,
      "letter": "MDST",
      "saved": 3600000
    }, {
      "from": 1919,
      "to": 1919,
      "month": 6,
      "day": [7, 1],
      "time": 0,
      "clock": "posix",
      "save": 60,
      "letter": "MSD",
      "saved": 0
    }, {
      "from": 1919,
      "to": 1919,
      "month": 7,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "MSK",
      "saved": 3600000
    }, {
      "from": 1918,
      "to": 1918,
      "month": 4,
      "day": [7, 31],
      "time": 1320,
      "clock": "wallclock",
      "save": 120,
      "letter": "MDST",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 8,
      "day": [7, 16],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "MST",
      "saved": 7200000
    }, {
      "from": 1917,
      "to": 1917,
      "month": 6,
      "day": [7, 1],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "MST",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1917,
      "month": 11,
      "day": [7, 28],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "MMT",
      "saved": 3600000
    }],
    "C-Eur": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1979,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "standard",
      "save": 60,
      "letter": "S"
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 120,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1944,
      "to": 1945,
      "month": 3,
      "day": [1, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [7, 16],
      "time": 120,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1944,
      "to": 1944,
      "month": 9,
      "day": [7, 2],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1943,
      "month": 2,
      "day": [7, 29],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1943,
      "to": 1943,
      "month": 9,
      "day": [7, 4],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 10,
      "day": [7, 2],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1940,
      "to": 1940,
      "month": 3,
      "day": [7, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1918,
      "month": 3,
      "day": [1, 15],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1918,
      "month": 8,
      "day": [1, 15],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1916,
      "to": 1916,
      "month": 3,
      "day": [7, 30],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1916,
      "to": 1916,
      "month": 9,
      "day": [7, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }],
    "Romania": [{
      "from": 1991,
      "to": 1993,
      "month": 2,
      "day": [0, -31],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1991,
      "to": 1993,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1980,
      "to": 1980,
      "month": 3,
      "day": [7, 5],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1980,
      "to": 1980,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1979,
      "to": 1979,
      "month": 4,
      "day": [7, 27],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1979,
      "to": 1979,
      "month": 8,
      "day": [0, -30],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1932,
      "to": 1939,
      "month": 9,
      "day": [0, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1933,
      "to": 1939,
      "month": 3,
      "day": [0, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1932,
      "to": 1932,
      "month": 4,
      "day": [7, 21],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }]
  }
};